import { Component, OnInit } from '@angular/core';
import {AuthService} from '../../../services/auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import {GeneralService} from '../../../services/general.service';
import {StaticMethods} from '../../../model/GeneralModels';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: [
    '../../../assets/vendor/mdi-font/css/material-design-iconic-font.min.css',
    '../../../assets/Content/src/css/lib.vendor.css',
    '../../../assets/Content/src/css/lib.picker.css',
    '../../../assets/Content/src/css/ini.bime.css',
    '../../../assets/vendor/font-awesome-4.7/css/font-awesome.min.css',
    '../../../assets/css/light.theme.css'
  ]
})
export class ConfirmComponent implements OnInit {
  productName = 'PET';
  viewList: any;
  private formsData: any;
  public viewInformation = {};
  translation: any = {};

  constructor(private authService: AuthService,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private generalService: GeneralService
              ) {
  }

  ngOnInit(): void {
    if (StaticMethods.checkState(this.router, ['viewList', 'formsData', 'translation'],
      `/${this.productName}/offers`)) {
      this.viewList = history.state.viewList;
      this.formsData = history.state.formsData;
      this.translation = history.state.translation;
      this.viewInformation = StaticMethods.preserveList(this.viewList);
    }
  }

  submit() {
    if (this.authService.decode() && this.authService.decode().Role === 'user') {
      this.generalService.createRequest(this.productName, this.formsData).subscribe(response => {
        if (response.success) {
          this.router.navigate([`/${this.productName}/details`], {
            state: {
              viewList: this.viewList,
              formsData: this.formsData,
              translation: this.translation,
              requestID: response.data
            }
          });
        }
      }, error => {
        console.log(error);
      });
    } else {
      this.router.navigate(['login'],
        {queryParams: {returnUrl: `/${this.productName}/confirm`}, state: history.state}
      );
    }
  }

}
